import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Illustration } from './media.js';
import { StoryBookPage } from './page.js';
export function BookCoverTemplate({ attributes, imageUrl, imageAlt, }) {
    return (_jsx(StoryBookPage, { attributes: attributes, children: _jsx(Illustration, { src: imageUrl, alt: imageAlt, style: { position: 'absolute', inset: 0, width: '100%', height: '100%' } }) }));
}
export function BackCoverTemplate({ attributes, imageUrl, imageAlt, }) {
    return (_jsx(StoryBookPage, { attributes: attributes, children: _jsx(Illustration, { src: imageUrl, alt: imageAlt, style: { position: 'absolute', inset: 0, width: '100%', height: '100%' } }) }));
}
//# sourceMappingURL=covers.js.map